import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import {
  UploadedDocument,
  TypableDropdown,
  DatePicker,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { formatDate } from '../../../../core-utils/helper-utils/helper';

export interface ReviewDoc {
  document_id: string;
  document_name: string;
  document_url?: string;
  service_agreement_name: string;
  health_care_partner: string;
  document_type: string;
  document_effective_date: string;
}

export interface ServiceAgreementOption {
  _id: string;
  service_agreement_name: string;
}

interface Props {
  doc: ReviewDoc;
  serviceAgreements: ServiceAgreementOption[];
  healthcarePartners: string[];
  docTypeOptions: string[];
  onFieldChange: (
     
    documentId: string,
     
    field: keyof ReviewDoc,
     
    value: string,
  ) => void;
   
  onPartnerInput: (documentId: string, value: string) => void;
  errorFields?: string[];
}

const useStyles = makeStyles()({
  row: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    padding: '12px 0',
    borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    '@media (max-width: 1100px)': {
      flexWrap: 'wrap',
      alignItems: 'stretch',
      padding: '12px',
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      borderRadius: '4px',
      marginBottom: '8px',
    },
  },
});

const ContractReviewRow: React.FC<Props> = ({
  doc,
  serviceAgreements,
  healthcarePartners,
  docTypeOptions,
  onFieldChange,
  onPartnerInput,
  errorFields,
}) => {
  const { classes } = useStyles();
  const hasError = (field: string) => errorFields?.includes(field);

  return (
    <Grid className={classes.row}>
      <UploadedDocument
        name={doc.document_name}
        size={''}
        handleDelete={() => {}}
        width="300px"
        truncateWidth="230px"
        hideDelete
      />

      {/* Service Agreement Type — dropdown of strings */}
      <TypableDropdown
        placeholder={'Select'}
        dropDownOptions={serviceAgreements.map((s) => s.service_agreement_name)}
        dropDownValues={serviceAgreements.map((s) => s.service_agreement_name)}
        value={doc.service_agreement_name}
        handleChange={(event: any) =>
          onFieldChange(
            doc.document_id,
            'service_agreement_name',
            event.target.value,
          )
        }
        height="40px"
        width="179px"
        handleInputChange={() => {}}
        hideTextField={true}
        error={hasError('service_agreement_name')}
      />

      {/* Healthcare Partner — dropdown + free text */}
      <TypableDropdown
        placeholder={'Select'}
        textFieldPlaceholder="Enter Healthcare Partner name"
        dropDownOptions={healthcarePartners}
        dropDownValues={healthcarePartners}
        value={doc.health_care_partner}
        handleChange={(event: any) =>
          onFieldChange(
            doc.document_id,
            'health_care_partner',
            event.target.value,
          )
        }
        handleInputChange={(value: string) =>
          onPartnerInput(doc.document_id, value)
        }
        height="40px"
        width="179px"
        disabled={doc.service_agreement_name === ''}
        error={hasError('health_care_partner')}
      />

      {/* Document Type — dropdown of strings */}
      <TypableDropdown
        placeholder={'Select'}
        dropDownOptions={docTypeOptions}
        dropDownValues={docTypeOptions}
        value={doc.document_type}
        handleChange={(event: any) =>
          onFieldChange(doc.document_id, 'document_type', event.target.value)
        }
        height="40px"
        width="165px"
        handleInputChange={() => {}}
        hideTextField={true}
        error={hasError('document_type')}
      />

      {/* Effective Date */}
      <DatePicker
        selectedDate={formatDate(doc.document_effective_date, 'MM-DD-YYYY')}
        handleChange={(date: any, value: any) =>
          onFieldChange(doc.document_id, 'document_effective_date', value)
        }
        height="40px"
        width="138px"
        minDate={undefined}
        maxDate={undefined}
        format="MM-dd-yyyy"
        placeholder="mm-dd-yyyy"
      />
    </Grid>
  );
};

export default ContractReviewRow;
